import { render } from "./Animation.vue?vue&type=template&id=6052c8b8"
import script from "./Animation.vue?vue&type=script&lang=ts"
export * from "./Animation.vue?vue&type=script&lang=ts"
script.render = render

export default script